<template>
  <div class="billing-details__wrapper">
    <SkCollapse class="billing-details__collapse">
      <template slot="labelLeft">
        <div class="billing-details__title">
          {{ $t('validate_quote.billing_details.title') }}
        </div>
      </template>
      <template slot="content">
        <div class="billing-details__content">
          <div class="billing-details__column">
            <div class="billing-details__row">
              <span class="billing-details__legend">
                {{ $t('validate_quote.billing_details.quotation_creation_date') }}
              </span>
              <span class="billing-details__data">
                {{ billingInfo.quotationCreationDate }}
              </span>
            </div>
            <div class="billing-details__row">
              <span class="billing-details__legend">
                {{ $t('validate_quote.billing_details.quotation_expiration_date') }}
              </span>
              <span class="billing-details__data">
                {{ billingInfo.quotationExpirationDate }}
              </span>
            </div>

            <div class="billing-details__row billing-details__row--billing-information">
              <span class="billing-details__legend">
                {{ $t('validate_quote.billing_details.starting_date') }}
              </span>
              <span class="billing-details__data">
                {{ billingInfo.startingDate }}
              </span>
            </div>

            <div
              v-if="billingInfo.billingOffsetDays"
              class="billing-details__row"
            >
              <span class="billing-details__legend">
                {{ $t('validate_quote.billing_details.billing_start_date') }}
              </span>
              <span class="billing-details__data">
                {{ billingInfo.startingDate }}
                {{ $tc('validate_quote.billing_details.billing_offset_date',
                       billingInfo.billingOffsetDays,
                       { days: billingInfo.billingOffsetDays }) }}
              </span>
            </div>
          </div>

          <div class="billing-details__column">
            <div class="billing-details__row billing-details__row--contact-information">
              <span class="billing-details__legend--contact-information">
                {{ $t('validate_quote.billing_details.from') }}
              </span>
              <span class="sk-text-medium-regular billing-details__data">
                {{ billingLine1(billingInfo.from) }}
                {{ billingLine2(billingInfo.from) }}
              </span>
            </div>
            <div class="billing-details__row billing-details__row--contact-information">
              <span class="billing-details__legend--contact-information">
                {{ $t('validate_quote.billing_details.to') }}
              </span>
              <span class="sk-text-medium-regular billing-details__data">
                {{ billingLine1(billingInfo.to) }}
                {{ billingLine2(billingInfo.to) }}
              </span>
            </div>
          </div>
        </div>
      </template>
    </SkCollapse>
  </div>
</template>

<script>
import { SkCollapse } from '@skelloapp/skello-ui';

export default {
  name: 'BillingDetails',
  components: { SkCollapse },
  props: {
    billingInfo: {
      type: Object,
      required: true,
    },
  },
  methods: {
    billingLine1(billingObject) {
      const lineComponent = [
        billingObject.company,
        billingObject.line1,
        billingObject.line2,
      ];

      // Remove empty elements if there are any, and list the rest
      return lineComponent.filter(Boolean).join(', ');
    },
    billingLine2(billingObject) {
      const lineComponent = [
        billingObject.zip,
        billingObject.city,
        billingObject.stateCode || billingObject.state,
        billingObject.country,
      ];
      // Remove empty elements if there are any, and list the rest
      return lineComponent.filter(Boolean).join(', ');
    },
  },
};
</script>

<style lang="scss" scoped>
.billing-details__wrapper {
  padding-bottom: 24px;
}

.billing-details__collapse {
  border: 1px solid $sk-grey-10;
  border-radius: 8px;
}

.billing-details__title {
  font-weight: $fw-semi-bold;
  font-size: 16px;
}

.billing-details__content {
  display: flex;
  align-self: stretch;
  padding: 0 16px 16px 16px;
  gap: 24px;
}

.billing-details__column {
  flex: 1 1 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.billing-details__row {
  display: flex;
  row-gap: 2px;
  column-gap: 8px;
  line-height: normal;
}

.billing-details__row--billing-information {
  flex-wrap: wrap;
}

.billing-details__row--contact-information {
  align-items: baseline;
}

.billing-details__legend {
  color: $sk-grey-50;
  white-space: nowrap;
}

.billing-details__legend--contact-information {
  min-width: 40px;
  color: $sk-grey-50;
}

.billing-details__data {
  word-break: normal;
  overflow-wrap: break-word;
}

</style>
